import restClient from '@api/RestClient';
import type * as schema from '@api/schema';
import {
    GroupAddDedicatedAccess,
    GroupAddLanes,
    GroupAddModes,
    GroupOperationInfo,
    GroupRemoveLanes,
} from '@api/groupUpdateApi/types';

export const groupUpdateApi = {
    groupUpdate(
        data: schema.paths['/services/replancity_RoadInfrastructureService/groupSaveAndUpdateV2']['get']['parameters']['query'],
        abortSignal: AbortSignal
    ): Promise<any[]> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_RoadInfrastructureGroupUpdateService/groupSaveAndUpdateV2`,
            data,
            fetchOptions: { signal: abortSignal },
        });
    },

    ptRoutesGroupUpdate(
        data: schema.paths['/services/replancity_PublicTransitService/groupSaveAndUpdate']['get']['parameters']['query'],
        abortSignal: AbortSignal
    ): Promise<any[]> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_PublicTransitService/groupSaveAndUpdate`,
            data,
            fetchOptions: { signal: abortSignal },
        });
    },

    groupManipulate: function (
        data: {
            task: {
                presetId: string;
                type: 'DELETE';
                targets: string[];
            };
        },
        abortSignal: AbortSignal
    ): Promise<any> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_RoadInfrastructureService/groupManipulate`,
            data,
            fetchOptions: { signal: abortSignal },
        });
    },

    listOperations: (abortSignal: AbortSignal): Promise<GroupOperationInfo[]> => {
        return restClient.fetch({
            method: 'GET',
            path: `services/replancity_RoadInfrastructureGroupUpdateService/listOperations`,
            fetchOptions: { signal: abortSignal },
        });
    },

    groupAddLanes: function (data: GroupAddLanes, abortSignal: AbortSignal): Promise<any> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_RoadInfrastructureGroupUpdateService/groupAddLanes`,
            data,
            fetchOptions: { signal: abortSignal },
        });
    },

    groupRemoveLanes: function (data: GroupRemoveLanes, abortSignal: AbortSignal): Promise<any> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_RoadInfrastructureGroupUpdateService/groupRemoveLanes`,
            data,
            fetchOptions: { signal: abortSignal },
        });
    },

    groupAddDedicatedAccess: function (
        data: GroupAddDedicatedAccess,
        abortSignal: AbortSignal
    ): Promise<any> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_RoadInfrastructureGroupUpdateService/groupAddDedicatedAccess`,
            data,
            fetchOptions: { signal: abortSignal },
        });
    },

    groupAddModes: function (data: GroupAddModes, abortSignal: AbortSignal): Promise<any> {
        return restClient.fetch({
            method: 'POST',
            path: `services/replancity_RoadInfrastructureGroupUpdateService/groupAddModes`,
            data,
            fetchOptions: { signal: abortSignal },
        });
    },
};
